import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LegalDataProviderService {

  renovacionVisado = {
    title: 'Renovación de Visado de Estudiante',
    subtitle: '',
    fieldForTitle: 'title',
    fieldForContent: 'description',
    description: 'La renovación de tu visado de estudiante en España implica varios pasos importantes. A continuación, te presentamos el proceso completo:',
    array: [
      {
        title: 'Documentación',
        description: 'Reunir todos los documentos necesarios: pasaporte, visado actual, comprobante de matrícula, seguro médico, y comprobante de medios económicos.'
      },
      {
        title: 'Rellenar formulario',
        description: 'Completar el formulario de solicitud correspondiente.'
      },
      {
        title: 'Cita previa',
        description: 'Solicitar una cita en la oficina de extranjería más cercana.'
      },
      {
        title: 'Acudir a la cita',
        description: 'Presentar tu solicitud y documentos en la cita.'
      },
      {
        title: 'Resolución',
        description: 'Esperar la resolución de tu solicitud.'
      }
    ]
  }

  permisoTrabajo = {
    title: 'Permisos de Trabajo',
    subtitle: '',
    fieldForTitle: 'title',
    fieldForContent: 'description',
    description: 'Si deseas trabajar mientras estudias en España, necesitarás un permiso de trabajo. Aquí te explicamos cómo obtenerlo:',
    array: [
      {
        title: 'Contrato de trabajo',
        description: 'Contar con un contrato de trabajo.'
      },
      {
        title: 'Cita previa',
        description: 'Solicitar una cita en la oficina de extranjería.'
      },
      {
        title: 'Documentación',
        description: 'Presentar tu solicitud junto con el contrato de trabajo y otros documentos requeridos.'
      },
      {
        title: 'Acudir a la cita',
        description: 'Esperar la resolución de tu solicitud.'
      }
    ]
  }

  reservaSesion = {
    title: '¿Necesitas asistencia legal?',
    text: 'Reserva una Sesión Legal con nuestro equipo de abgados Bach Legal localizado en Barcelona.',
    cta: 'Reservar ahora',
    subtitle: 'B',
    shortPara: '',
    description: '',
    array: [],
  }

  constructor() { }

  getRenovacionData(){
    return this.renovacionVisado;
  }

  getPermisoTrabajoData(){
    return this.permisoTrabajo;
  }

  getReservarSesion(){
    return this.reservaSesion;
  }
}
